import React, { useMemo } from 'react'

import { MapPinArea } from '@phosphor-icons/react'
import { Column, Text } from 'Components/UI'

import { GOOGLE_MAP_LINK, OFFICE_ADDRESSES } from 'Constants/ContactData'

import { Container, StyledLink } from './styles'

type Props = {
  secondary?: boolean
}

function Addresses({ secondary }: Props) {
  const list = useMemo(
    () =>
      OFFICE_ADDRESSES.map(item => (
        <Column gap={4} key={item.id} maxWidth={secondary ? 240 : 'unset'}>
          <Text bold inverse screen20>
            {item.city}
          </Text>

          <StyledLink
            href={GOOGLE_MAP_LINK(item.location)}
            rel="noopener noreferrer"
            target="_blank"
          >
            <MapPinArea size={28} weight="fill" />

            <Text inverse medium screen14>
              {item.address}
            </Text>
          </StyledLink>
        </Column>
      )),
    [secondary],
  )

  return secondary ? (
    <Container flexDirection={['column', 'column', 'column', 'row']} gap={13}>
      {list}
    </Container>
  ) : (
    <Column gap={8} maxWidth="260px">
      {list}
    </Column>
  )
}

export default Addresses
